export const formatUserDisplayName = (user, fallback = '-') => {
  if (!user) return fallback;

  const firstName = String(user.firstName || '').trim();
  const familyName = String(user.studentProfile?.familyName || '').trim();
  const lastName = String(user.lastName || familyName || '').trim();
  const lastFirst = [lastName, firstName].filter(Boolean).join(' ').trim();

  if (lastFirst) return lastFirst;

  const fullName = String(user.fullName || user.name || '').trim();
  if (fullName) return fullName;

  const email = String(user.email || '').trim();
  if (email) return email;

  return fallback;
};
